var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "css-3_5968242 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon2989_00000091712160093483359120000013545222466388029605_",
    d: "M99.0882 22.7969L91.6012 106.67L57.9469 116L24.3853 106.683L16.9062 22.7969H99.0882Z",
    fill: "#004CE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2991_00000130636505511401349330000011479272249651210121_",
    d: "M85.1943 101.33L91.5924 29.6562H58V108.869L85.1943 101.33Z",
    fill: "#0065F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon2993_00000027586116533142052040000014804943466300760462_",
    d: "M34.0469 60.7695L34.969 71.0577H57.9923L62.4177 65.9136L57.9923 60.7695H34.0469Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2995_00000098936504455534668280000009583779879621411251_",
    d: "M57.9935 39.9453H57.958H32.1953L33.1306 50.2337H57.9935L62.419 45.0894L57.9935 39.9453Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon2997_00000011734588395863960860000002272664363377641402_",
    d: "M57.9933 98.1946L62.4187 92.7388L57.9933 87.4905L57.9482 87.5025L46.49 84.4085L45.7575 76.2031H40.1898H35.4297L36.8711 92.3573L57.9459 98.2078L57.9933 98.1946Z",
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2999_00000183935336956994173500000009856227378309738643_",
    d: "M36.25 0H48.7109V5.21094H41.4609V10.4219H48.7109V15.6328H36.25V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3001_00000096055226761582317920000005110122629658984122_",
    d: "M51.2031 0H63.6641V4.53125H56.4141V5.4375H63.6641V15.8594H51.2031V11.1016H58.4531V10.1953H51.2031V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3003_00000136402835624896882680000006132478931596835508_",
    d: "M66.1562 0H78.6172V4.53125H71.3672V5.4375H78.6172V15.8594H66.1562V11.1016H73.4062V10.1953H66.1562V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon3005_00000173137955367200700520000015002477665718237887_",
    d: "M70.6299 71.0573L69.4356 84.4005L57.9609 87.4976V98.2013L79.0526 92.3558L79.2073 90.6176L81.6249 63.5318L81.876 60.7691L83.7333 39.9453H57.9609V50.2337H72.4582L71.5221 60.7691H57.9609V71.0573H70.6299Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.5f2787e798f73b648a9e7a0ae9292ae1.svg";
export { ForwardRef as ReactComponent };